export default {
    title_list: 'Пользователи',
    title_page: 'Пользователь',
    title_create_page: 'Создать пользователя',
    title_edit_page: 'Изменить пользователя',

    labels: {
        subscriptions: 'Подписки',
        transactions: 'Платежные транзакции',
        drag_in_drop: 'Перенесите или нажмите чтобы выбрать файлы',
        date: 'Дата',
        braintree_id: 'Braintree ID',
        subscription: 'Подписка',
        subscription_start: 'Дата начала',
        subscription_end: 'Дата окончания',
        plan: 'Тарифный план',
        gifts: 'Подарки',
        gift: 'Подарок',
        price: 'Стоимость',
        cost: 'Стоимость',
        card: 'Карта',
        recipient: 'Получатель',
        brain_health_id: 'Brain health ID',
    },

    filter: {
        labels: {
            name: 'Никнейм',
            first_name: 'Имя',
            last_name: 'Фамилия',
            email: 'Email',
            subscription: 'Подписка',
        }
    },

    table: {
        labels: {
            id: 'ID',
            name: 'Никнейм',
            first_name: 'Имя',
            last_name: 'Фамилия',
            email: 'Email',
            provider: 'Провайдер',
            subscription: 'Подписка',
            count_artifacts: 'Кол-во артефактов',
        }
    },

    buttons: {

    },

    form: {
        name: 'Никнейм',
        email: 'Email',
        preserve_email: 'Доверенный email',
        email_verified_at: 'Дата подтверждения email',
        first_name: 'Имя',
        middle_name: 'Отчество',
        last_name: 'Фамилия',
        photo: 'Аватар',
        year: 'Год рождения',
        month: 'Месяц рождения',
        password: 'Пароль',
        created_at: 'Дата создания',
        updated_at: 'Дата изменения',
        provider: 'Провайдер авторизации',
        provider_id: 'ID провайдера авторизации',
        type_id: 'Тип пользователя',
    },
}
